import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import { getCounterValue } from '../../Counter'
import { FloatingTooltip } from '../../Floating'
import { getUserMultiValueName } from '../UserMultiValue'

import {
  QA_NAME_USER_AVATAR_GROUP,
  QA_NAME_USER_AVATAR_GROUP_MORE,
  USER_AVATAR_GROUP_DEFAULT_VISIBLE_COUNT,
} from './UserAvatarGroup.constants'
import {
  getUserAvatarGroupItemTooltip,
  getUserAvatarGroupMoreTooltip,
  toUserAvatarGroupItems,
} from './UserAvatarGroup.utils'

import * as styles from './UserAvatarGroup.module.css'

import UserIcon from '../../../icons/user.svg'

function UserAvatarGroup({
  users = EMPTY_LIST,
  visibleCount = USER_AVATAR_GROUP_DEFAULT_VISIBLE_COUNT,
}) {
  const { t } = useTranslation()

  const items = toUserAvatarGroupItems(users)

  const visibleItems = items.slice(0, visibleCount)

  const hiddenItems = items.slice(visibleCount)

  return items.length > 0 ? (
    <div
      {...getQaSelector({ value: QA_NAME_USER_AVATAR_GROUP })}
      className={styles.UserAvatarGroup}
    >
      {visibleItems.map(item => (
        <FloatingTooltip
          content={getUserAvatarGroupItemTooltip({ item, t })}
          key={item.key}
        >
          <Avatar
            Icon={item.isSystem ? UserIcon : null}
            className={styles.avatar}
            color={item.avatarColor}
            size={AVATAR_HEIGHT_24}
            src={item.avatar}
            text={getUserMultiValueName({ t, user: item })}
          />
        </FloatingTooltip>
      ))}
      {hiddenItems.length > 0 ? (
        <FloatingTooltip
          content={getUserAvatarGroupMoreTooltip({ items: hiddenItems, t })}
        >
          <Avatar
            className={styles.more}
            qaName={QA_NAME_USER_AVATAR_GROUP_MORE}
            size={AVATAR_HEIGHT_24}
          >
            <span className={styles.moreText}>
              {getCounterValue(hiddenItems.length, true)}
            </span>
          </Avatar>
        </FloatingTooltip>
      ) : null}
    </div>
  ) : null
}

export default UserAvatarGroup
